import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

const EditBudgetModal = ({ budget, getAgentName, amount, onAmountChange, onHide, onSubmit, saving }) => (
  <Modal show={Boolean(budget)} onHide={onHide} centered>
    <Form onSubmit={onSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>
          {budget && budget.exists ? "Modifica budget" : "Crea budget"} — {budget && getAgentName(budget.idAgente)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {budget && !budget.exists && Number(budget.prefillAmount) > 0 && (
          <div className="alert alert-light-info">
            Importo precompilato dal budget dell&apos;anno precedente; puoi modificarlo prima di salvare.
          </div>
        )}
        <Form.Group>
          <Form.Label>Budget annuale (€)</Form.Label>
          <Form.Control
            autoFocus
            type="number"
            min="0"
            step="0.01"
            value={amount}
            onChange={onAmountChange}
            required
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={saving}>
          Annulla
        </Button>
        <Button type="submit" disabled={saving}>
          {saving ? "Salvataggio…" : "Salva budget"}
        </Button>
      </Modal.Footer>
    </Form>
  </Modal>
);

export default EditBudgetModal;
